<template>
    <router-link tag="a"
                 target="_blank"
                 class="case-item"
                 :to="{name:'caseDetal',params:{id:info.id}}">
        <div class="case-pic">
            <img :src="info.bgImg" style="border-radius:14px;"
                 alt>
            <div class="case-tag">
                <span class="tag-view"
                      v-for="(item,index) in info.tags"
                      :key="index">{{item}}</span>
            </div>
        </div>
        <h2 class="case-tit">{{info.title}}</h2>
        <div class="case-handle">
            <span class="zhouqi">项目周期：{{info.cycle}}</span>
            <!--零星 no-star、 一星 one-star、 二星 two-star、 三星 three-star 、四星 four-star、 五星 five-star -->
            <i class="star-icon"
               :class="info.stars"></i>
        </div>
        <div class="case-describe">{{info.desc}}</div>
        
    </router-link>
</template>

<script>
export default {
    name: 'caseItem',
    data() {
        return {};
    },
    props: {
        info: Object
    },
};
</script>

<style>
.case-column .case-handle{padding-top:4px;}
.case-column .case-describe{padding-top:8px;}
.case-column .case-item{margin: 0 20px 20px 0;}
.zhouqi{overflow: hidden;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;width: 150px;display: -webkit-inline-box;}
</style>
